import React, { useState } from 'react';
import toast from 'react-hot-toast';
import { useGetCurrentLocationOfQrMutation } from '../../../../features/supplyBeam/supplyBeamData/checkoutListAPI';
import LinksComponent from '../../../../components/Tenant/LinksComponent/LinksComponent';

const QrTracking = () => {
  const [batchCode, setBatchCode] = useState('');
  const [trackingData, setTrackingData] = useState(null);

  const [
    getCurrentLocation,
    { isLoading }
  ] = useGetCurrentLocationOfQrMutation();

  const handleTrack = async (e) => {
    e.preventDefault();
    if (!batchCode.trim()) {
      toast.error('Please enter a valid batch running code');
      return;
    }

    try {
      const response = await getCurrentLocation({
        token: sessionStorage.getItem('access_token'),
        tenant_id: JSON.parse(sessionStorage.getItem('vendorData'))?.tenant_id,
        body: {
          batch_running_code: batchCode.trim()
        }
      });

      if (response?.data?.success) {
        const resultData = response.data.data || response.data.body;
        if (!resultData?.current_location_name) {
             toast.error('Location not found for this QR');
             setTrackingData(null);
        } else {
             toast.success('Tracking information retrieved successfully!');
             setTrackingData(resultData);
        }
      } else {
        toast.error(response?.error?.data?.message || 'Failed to fetch tracking data');
        setTrackingData(null);
      }
    } catch (error) {
      console.error(error);
      toast.error('An unexpected error occurred');
      setTrackingData(null);
    }
  };

  const clearData = () => {
      setBatchCode('');
      setTrackingData(null);
  };

  return (
    <div className="flex w-full bg-gray-100 min-h-screen justify-center">
      <div className="w-full">
        {/* Header Section */}
        <div className="border-b bg-white border-gray-300 pl-6 py-4 shadow-sm text-2xl font-bold flex justify-between items-center text-gray-800 tracking-tight">
          QR Live Tracking
          <LinksComponent />
        </div>

        <div className="p-6 max-w-5xl mx-auto">
          {/* Search Section */}
          <div className="bg-white shadow-lg rounded-2xl p-6 mb-6 transform transition-all hover:shadow-xl border border-gray-100">
            <h2 className="text-lg font-semibold text-gray-700 mb-4">Track Batch Code</h2>
            <form onSubmit={handleTrack} className="flex flex-col md:flex-row gap-4 items-end">
              <div className="w-full md:w-2/3">
                <label className="block text-sm font-medium leading-6 text-gray-600 mb-2">
                  Batch Running Code
                </label>
                <div className="relative">
                  <div className="absolute inset-y-0 left-0 flex items-center pl-3 pointer-events-none">
                    <svg className="w-5 h-5 text-gray-400" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 20 20">
                      <path stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="m19 19-4-4m0-7A7 7 0 1 1 1 8a7 7 0 0 1 14 0Z"/>
                    </svg>
                  </div>
                  <input
                    type="text"
                    className="block w-full p-4 pl-10 text-sm text-gray-900 border border-gray-200 rounded-xl bg-gray-50 focus:ring-blue-500 focus:border-blue-500 transition-colors shadow-sm"
                    placeholder="Enter batch running code (e.g. BATCH123)..."
                    value={batchCode}
                    onChange={(e) => setBatchCode(e.target.value)}
                  />
                </div>
              </div>
              <div className="w-full md:w-1/3 flex gap-3 h-full">
                <button
                  type="submit"
                  disabled={isLoading}
                  className="w-full flex-1 text-white bg-gradient-to-r from-blue-600 to-blue-700 hover:from-blue-700 hover:to-blue-800 focus:ring-4 focus:outline-none focus:ring-blue-300 font-medium rounded-xl text-sm px-5 py-4 text-center transition-all shadow-md transform hover:-translate-y-0.5"
                >
                  {isLoading ? 'Tracking...' : 'Track Location'}
                </button>
                <button
                  type="button"
                  onClick={clearData}
                  className="flex-1 text-gray-700 bg-gray-100 hover:bg-gray-200 border border-gray-200 focus:ring-4 focus:outline-none focus:ring-gray-100 font-medium rounded-xl text-sm px-5 py-4 text-center transition-all shadow-sm"
                >
                  Clear
                </button>
              </div>
            </form>
          </div>

          {/* Results Section */}
          {trackingData ? (
            <div className="bg-white shadow-xl rounded-2xl overflow-hidden border border-gray-100 animate-[fadeIn_0.5s_ease-out]">
              <div className="bg-gradient-to-r from-blue-50 to-indigo-50 p-8 border-b border-gray-200 relative overflow-hidden">
                <div className="absolute top-0 right-0 -mt-10 -mr-10 text-blue-100 opacity-50">
                    <svg className="w-64 h-64" fill="currentColor" viewBox="0 0 24 24">
                        <path d="M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7zm0 9.5c-1.38 0-2.5-1.12-2.5-2.5s1.12-2.5 2.5-2.5 2.5 1.12 2.5 2.5-1.12 2.5-2.5 2.5z"/>
                    </svg>
                </div>
                
                <div className="relative z-10 flex flex-col md:flex-row items-center gap-6">
                    <div className="flex-shrink-0 w-24 h-24 bg-white rounded-full flex items-center justify-center shadow-lg border-4 border-blue-100">
                        <svg className="w-10 h-10 text-blue-600" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.243-4.243a8 8 0 1111.314 0z"></path>
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M15 11a3 3 0 11-6 0 3 3 0 016 0z"></path>
                        </svg>
                    </div>
                    <div>
                        <p className="text-sm font-semibold text-blue-600 uppercase tracking-wider mb-1">Current Location</p>
                        <h3 className="text-4xl font-extrabold text-gray-900 tracking-tight">
                            {trackingData.current_location_name}
                        </h3>
                        <p className="text-gray-500 mt-2 font-medium flex items-center gap-2">
                            <span className="w-2 h-2 rounded-full bg-green-500 animate-pulse"></span>
                            Live Status
                        </p>
                    </div>
                </div>
              </div>

              <div className="p-8 grid grid-cols-1 md:grid-cols-2 gap-8">
                {/* QR Details Card */}
                <div className="bg-gray-50 rounded-xl p-6 border border-gray-100">
                    <h4 className="text-lg font-bold text-gray-800 mb-4 flex items-center gap-2">
                        <svg className="w-5 h-5 text-gray-500" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 4v1m6 11h2m-6 0h-2v4m0-11v3m0 0h.01M12 12h4.01M16 20h4M4 12h4m12 0h.01M5 8h2a1 1 0 001-1V5a1 1 0 00-1-1H5a1 1 0 00-1 1v2a1 1 0 001 1zm12 0h2a1 1 0 001-1V5a1 1 0 00-1-1h-2a1 1 0 00-1 1v2a1 1 0 001 1zM5 20h2a1 1 0 001-1v-2a1 1 0 00-1-1H5a1 1 0 00-1 1v2a1 1 0 001 1z"></path></svg>
                        QR Details
                    </h4>
                    <ul className="space-y-4">
                        <li className="flex justify-between items-center border-b border-gray-200 pb-2">
                            <span className="text-gray-500 font-medium">Batch Code</span>
                            <span className="text-gray-900 font-semibold">{trackingData.qr_details?.batch_running_code}</span>
                        </li>
                        <li className="flex justify-between items-center border-b border-gray-200 pb-2">
                            <span className="text-gray-500 font-medium">Unique Code</span>
                            <span className="text-gray-900 font-semibold">{trackingData.qr_details?.unique_code}</span>
                        </li>
                        <li className="flex justify-between items-center pb-2">
                            <span className="text-gray-500 font-medium">QR Type</span>
                            <span className="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-blue-100 text-blue-800">
                                {trackingData.qr_details?.qr_type === "1" ? "Child" : trackingData.qr_details?.qr_type === "2" ? "Parent" : "Carton"}
                            </span>
                        </li>
                    </ul>
                </div>

                {/* History/Scan Details Card */}
                <div className="bg-gray-50 rounded-xl p-6 border border-gray-100">
                    <h4 className="text-lg font-bold text-gray-800 mb-4 flex items-center gap-2">
                        <svg className="w-5 h-5 text-gray-500" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z"></path></svg>
                        Last Scan Record
                    </h4>
                    <ul className="space-y-4">
                        <li className="flex justify-between items-center border-b border-gray-200 pb-2">
                            <span className="text-gray-500 font-medium">Scanned By</span>
                            <span className="text-gray-900 font-semibold">{trackingData.location_history_details?.user_name || "Unknown"}</span>
                        </li>
                        <li className="flex justify-between items-center border-b border-gray-200 pb-2">
                            <span className="text-gray-500 font-medium">Recorded At</span>
                            <span className="text-gray-900 font-semibold">
                                {new Date(trackingData.location_history_details?.created_at).toLocaleString()}
                            </span>
                        </li>
                        <li className="flex justify-between items-center pb-2">
                            <span className="text-gray-500 font-medium">Action Type</span>
                            <span className="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-purple-100 text-purple-800 uppercase tracking-wide">
                                {trackingData.location_history_details?.batch_type || "SCAN"}
                            </span>
                        </li>
                    </ul>
                </div>
              </div>
            </div>
          ) : (
            <div className="bg-white shadow-sm rounded-2xl p-12 border border-gray-200 text-center flex flex-col items-center justify-center">
                <div className="w-24 h-24 bg-gray-50 rounded-full flex items-center justify-center mb-6">
                    <svg className="w-12 h-12 text-gray-300" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.5" d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"></path>
                    </svg>
                </div>
                <h3 className="text-xl font-bold text-gray-700 mb-2">Ready to Track</h3>
                <p className="text-gray-400 max-w-sm">
                    Enter a batch running code in the search bar above to see its current real-time location in the supply chain.
                </p>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default QrTracking;
